<template>
  <p v-if="number">
    <sensitive-data-wrapper>
      <template v-if="dnc">
        <del>{{ numberFormatted }}</del>
        <small>DNC</small>
      </template>
      <template v-else>{{ numberFormatted }} <span v-if="isPrimary">(primary)</span></template>
    </sensitive-data-wrapper>
  </p>
</template>

<script>
import utils from "../../../services/utils";
import SensitiveDataWrapper from "../../../components/SensitiveDataWrapper.vue";

export default {
  name: "PhoneNumberDisplay",
  components: {SensitiveDataWrapper},
  props: {
    number: {
      type: String | null,
      required: true,
    },
    dnc: {
      type: Boolean,
      default: false,
    },
    isPrimary: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    numberFormatted() {
      return utils.formatNumber(this.number)
    }
  },
}
</script>

<style scoped>

</style>
